import { lazy } from 'react';
import HappySchoolRoutes from './HappySchool';
import MySpaceRoutes from './MySpace';
const UserCenterRoutes = [
    {
        label: '',
        key: 'UserCenter',
        path: '/user-center',
        redirect: '/home',
        element: lazy(() => import('@/components/Layout/UserCenterLayout')),
        children: [
            {
                label: '首页',
                key: 'home',
                path: 'home',
                show: true,
                element: lazy(() => import('@/page/Home'))
            },
            ...HappySchoolRoutes,
            ...MySpaceRoutes,
            {
                label: '个人中心',
                key: 'safety-center',
                path: 'safety-center',
                element: lazy(() => import('@/page/SafetyCenter/index')),
                show: true
            },
            {
                label: '客服中心',
                key: 'customer-service-center',
                path: 'customer-service-center',
                element: lazy(() => import('@/page/CustomerServiceCenter')),
                show: true
            }
        ]
    }
];
export default UserCenterRoutes;
